import { render, staticRenderFns } from "./RegattaRoundList.vue?vue&type=template&id=3054ca98&scoped=true&"
import script from "./RegattaRoundList.vue?vue&type=script&lang=js&"
export * from "./RegattaRoundList.vue?vue&type=script&lang=js&"
import style0 from "./RegattaRoundList.vue?vue&type=style&index=0&id=3054ca98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054ca98",
  null
  
)

export default component.exports